module.exports = __webpack_public_path__ + "img/AddToQueueOutlined.5013dd54.svg";